import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../components/common/SafeIcon';

const {FiExternalLink,FiTrendingUp,FiUsers,FiStar,FiArrowRight}=FiIcons;

const Portfolio=()=> {
  const portfolioItems=[ 
    {title: 'Given Ndlovu & Thibela Attorneys',category: 'Professional Services',description: 'Complete website redesign and hosting migration for a leading Johannesburg law firm.',image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',results: [ '45% increase in online enquiries','60% faster page loading times','99.9% uptime achieved' ],services: ['Web Design','Web Hosting','Email Hosting'],caseStudyUrl: 'https://www.gnt.co.za'},{title: 'Business & Personal Coach',category: 'Professional Services',description: 'Designed a modern website with online booking for a coaching practice.',image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',results: [ '90% increase in online bookings','40% growth in client sign-ups','Improved client engagement' ],services: ['Web Design','Booking System','Mobile App'],caseStudyUrl: 'https://www.bpcoach.co.za/'},{title: 'RSA Solutions',category: 'Business Consulting',description: 'Professional website and comprehensive hosting solution for a management consulting firm.',image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',results: [ '50% reduction in bounce rate','25% increase in consultation bookings','Enhanced professional credibility' ],services: ['Web Design','Web Hosting','SEO Optimisation'],caseStudyUrl: 'https://www.rsasolutions.co.za/'},{title: 'Gauteng Manufacturing Co.',category: 'Manufacturing',description: 'Industrial website design with product catalogue and client portal integration.',image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',results: [ '70% increase in product enquiries','Streamlined client communication','Improved supplier relationships' ],services: ['Web Design','Client Portal','Database Integration'],caseStudyUrl: 'https://gpmanu.primehost.co.za/'},{title: 'Creative Solutions Agency',category: 'Creative Industry',description: 'Modern portfolio website with integrated e-commerce functionality for a creative design agency.',image: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',results: [ '80% increase in portfolio views','35% improvement in client conversions','Mobile-responsive design' ],services: ['Web Design','E-commerce','Mobile Optimisation'],caseStudyUrl: 'https://cr8solu.primehost.co.za/'},{title: 'Durban Tech Startup',category: 'Technology',description: 'Modern SaaS platform website with integrated customer onboarding and support systems.',image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',results: [ '120% increase in user signups','65% reduction in support tickets','Scalable infrastructure' ],services: ['Web Design','SaaS Integration','Scalable Hosting'],caseStudyUrl: null} 
  ];

  const industries=[ 
    'Professional Services','Creative Industry','Business Consulting','Manufacturing','Hospitality','Technology','Healthcare','Education' 
  ];

  const handleCaseStudyClick=(item)=> {
    if (item.caseStudyUrl) {
      // External link - open in new tab 
      window.open(item.caseStudyUrl,'_blank','noopener,noreferrer');
    } else {
      // Internal case study - could navigate to a detailed case study page 
      // For now,we'll scroll to contact form 
      window.location.hash='#/contact#contact-form';
    }
  };

  return ( 
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="pt-20" > 
      {/* Hero Section */} 
      <section className="bg-gradient-to-br from-gray-50 to-white py-20"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6}} className="text-center" > 
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6"> Our portfolio of successful projects </h1> 
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8"> Discover how we've helped South African businesses transform their digital presence with reliable hosting,professional design,and exceptional results. </p> 
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-2xl mx-auto"> 
              <div className="bg-primary-50 rounded-lg p-4"> 
                <div className="text-2xl font-bold text-primary-500 mb-1">35%</div> 
                <div className="text-sm text-gray-600">Average increase in page views</div> 
              </div> 
              <div className="bg-primary-50 rounded-lg p-4"> 
                <div className="text-2xl font-bold text-primary-500 mb-1">28%</div> 
                <div className="text-sm text-gray-600">Average reduction in bounce rates</div> 
              </div> 
              <div className="bg-primary-50 rounded-lg p-4"> 
                <div className="text-2xl font-bold text-primary-500 mb-1">99.9%</div> 
                <div className="text-sm text-gray-600">Uptime achieved across all projects</div> 
              </div> 
            </div> 
          </motion.div> 
        </div> 
      </section> 

      {/* Portfolio Grid */} 
      <section className="py-20 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"> 
            {portfolioItems.map((item,index)=> ( 
              <motion.div key={index} initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: index * 0.1}} viewport={{once: true}} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300" > 
                <div className="relative"> 
                  <img src={item.image} alt={item.title} className="w-full h-48 object-cover" /> 
                  <div className="absolute top-4 left-4"> 
                    <span className="bg-primary-500 text-white px-3 py-1 rounded-full text-sm font-medium"> {item.category} </span> 
                  </div> 
                </div> 
                <div className="p-6"> 
                  <h3 className="text-xl font-bold text-gray-900 mb-2"> {item.title} </h3> 
                  <p className="text-gray-600 mb-4 text-sm leading-relaxed"> {item.description} </p> 
                  <div className="mb-4"> 
                    <h4 className="text-sm font-semibold text-gray-900 mb-2">Key results:</h4> 
                    <ul className="space-y-1"> 
                      {item.results.map((result,resultIndex)=> ( 
                        <li key={resultIndex} className="text-sm text-gray-600 flex items-center space-x-2"> 
                          <SafeIcon icon={FiTrendingUp} className="w-3 h-3 text-green-500" /> 
                          <span>{result}</span> 
                        </li> 
                      ))} 
                    </ul> 
                  </div> 
                  <div className="mb-6"> 
                    <h4 className="text-sm font-semibold text-gray-900 mb-2">Services provided:</h4> 
                    <div className="flex flex-wrap gap-2"> 
                      {item.services.map((service,serviceIndex)=> ( 
                        <span key={serviceIndex} className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs" > {service} </span> 
                      ))} 
                    </div> 
                  </div> 
                  <button onClick={()=> handleCaseStudyClick(item)} className="w-full bg-primary-500 text-white py-2 px-4 rounded-lg font-medium hover:bg-primary-600 transition-colors duration-200 flex items-center justify-center space-x-2" > 
                    <span>{item.caseStudyUrl ? 'Visit website' : 'View case study'}</span> 
                    <SafeIcon icon={FiExternalLink} className="w-4 h-4" /> 
                  </button> 
                </div> 
              </motion.div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* Industries Served */} 
      <section className="py-20 bg-gray-50"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.6}} viewport={{once: true}} className="text-center mb-16" > 
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4"> Industries we serve </h2> 
            <p className="text-xl text-gray-600"> Our expertise spans across diverse sectors throughout South Africa </p> 
          </motion.div> 
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6"> 
            {industries.map((industry,index)=> ( 
              <motion.div key={index} initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: index * 0.1}} viewport={{once: true}} className="bg-white p-6 rounded-xl text-center hover:bg-primary-50 transition-colors duration-200" > 
                <div className="text-lg font-semibold text-gray-900"> {industry} </div> 
              </motion.div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* Performance Metrics */} 
      <section className="py-20" style={{backgroundColor: '#D14932'}}> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.6}} viewport={{once: true}} className="text-center text-white" > 
            <h2 className="text-3xl lg:text-4xl font-bold mb-6"> Performance improvements our clients experience </h2> 
            <p className="text-xl text-red-100 mb-12 max-w-3xl mx-auto"> These metrics represent average improvements across our client projects,demonstrating the real impact of professional hosting and design. </p> 
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"> 
              {[ 
                {metric: '35%',label: 'Increase in page views',icon: FiTrendingUp},{metric: '28%',label: 'Reduction in bounce rates',icon: FiUsers},{metric: '50%',label: 'Faster loading times',icon: FiTrendingUp},{metric: '99.9%',label: 'Uptime achieved',icon: FiTrendingUp} 
              ].map((stat,index)=> ( 
                <motion.div key={index} initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: index * 0.1}} viewport={{once: true}} className="text-center" > 
                  <div className="bg-white bg-opacity-20 p-4 rounded-xl w-16 h-16 flex items-center justify-center mx-auto mb-4"> 
                    <SafeIcon icon={stat.icon} className="w-8 h-8 text-white" /> 
                  </div> 
                  <div className="text-3xl font-bold mb-2">{stat.metric}</div> 
                  <div className="text-red-100">{stat.label}</div> 
                </motion.div> 
              ))} 
            </div> 
          </motion.div> 
        </div> 
      </section> 

      {/* CTA Section */} 
      <section className="py-20 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"> 
          <motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.6}} viewport={{once: true}} > 
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6"> Ready to join our success stories? </h2> 
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto"> Let us help you achieve similar results with professional hosting,design,and ongoing support tailored to your business needs. </p> 
            <div className="flex flex-col sm:flex-row gap-4 justify-center"> 
              <Link to="/contact" className="bg-primary-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-primary-600 transition-colors duration-200 inline-flex items-center justify-center space-x-2" > 
                <span>Start your project</span> 
                <SafeIcon icon={FiArrowRight} className="w-4 h-4" /> 
              </Link> 
              <Link to="/services" className="border border-gray-300 text-gray-700 px-8 py-4 rounded-lg font-semibold hover:border-primary-500 hover:text-primary-500 transition-colors duration-200" > View our services </Link> 
            </div> 
          </motion.div> 
        </div> 
      </section> 
    </motion.div> 
  );
};

export default Portfolio;